import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Loader2, Package, ShieldAlert } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Panel } from "@/components/common/Panel";
import { formatChf } from "@/lib/sales";

export default function SalesOffers() {
  const { t } = useTranslation();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/sales/offers").then((r) => setD(r.data)).catch(() => setD(false)); }, []);

  return (
    <div data-testid="sales-offers-page">
      <PageHeader title={t("sales.offers.title")} subtitle={t("sales.offers.subtitle")} />

      {!d ? (
        <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-fundio-gold" /></div>
      ) : (
        <div className="space-y-6">
          <Panel title={t("sales.offers.baseTitle")} subtitle={t("sales.offers.baseSub")} testid="offers-base-panel">
            <div className="grid grid-cols-2 gap-3 p-3 sm:grid-cols-3 lg:grid-cols-5">
              {d.base_plans.map((p) => (
                <div key={p.key} data-testid={`offer-base-${p.key}`} className="rounded-xl border border-fundio-border bg-white px-4 py-3">
                  <p className="font-display text-sm font-semibold text-fundio-ink">{p.name}</p>
                  <p className="mt-1 font-display text-xl font-semibold text-fundio-gold-deep">{formatChf(p.price_chf)}</p>
                  <p className="mt-1 text-[11px] text-fundio-muted">{p.note}</p>
                </div>
              ))}
            </div>
          </Panel>

          <div data-testid="offer-pilot-notice" className="flex items-center gap-2 rounded-lg border border-status-warning-border bg-status-warning-bg/50 px-4 py-2.5 text-xs font-semibold text-status-warning">
            <ShieldAlert className="h-4 w-4" /> {d.pilot_notice}
          </div>

          <Panel title={t("sales.offers.pilotTitle")} subtitle={t("sales.offers.pilotSub")} testid="offers-pilot-panel">
            <div className="grid grid-cols-1 gap-3 p-3 sm:grid-cols-2 lg:grid-cols-4">
              {d.pilot_offers.map((o) => (
                <div key={o.key} data-testid={`offer-pilot-${o.key}`} className="relative rounded-xl border border-fundio-border bg-white px-4 py-4">
                  <span className="absolute right-3 top-3 rounded border border-status-warning-border bg-status-warning-bg px-1.5 py-0.5 text-[10px] font-semibold text-status-warning">{t("sales.offers.pilotTag")}</span>
                  <p className="font-display text-base font-semibold text-fundio-ink">{o.name}</p>
                  <p className="mt-1 font-display text-2xl font-semibold text-fundio-gold-deep">{formatChf(o.price_chf)}<span className="text-xs font-normal text-fundio-muted">{t("sales.offers.perMonth")}</span></p>
                  <p className="mt-2 flex items-start gap-1.5 text-xs text-fundio-muted"><Package className="mt-0.5 h-3.5 w-3.5 text-fundio-faint" />{o.includes}</p>
                </div>
              ))}
            </div>
          </Panel>
        </div>
      )}
    </div>
  );
}
